export default __webpack_public_path__ + "static/media/37.efd77399.jpg";